import React from 'react';
import { ReCaptcha } from 'react-recaptcha-v3';
import SocialButton from './SocialButton';

const SocialButtonsView = ({
  requestType,
  isLoading,
  socials,
  error,
  reacaptcha_sitekey,
  isRecaptchaEnabled,
  authorization,
  verifyCallback,
}) => (
  <div className="auth-buttons">
    {isRecaptchaEnabled && reacaptcha_sitekey && reacaptcha_sitekey.v3 && (
      <ReCaptcha sitekey={reacaptcha_sitekey.v3} action="oauth" verifyCallback={verifyCallback} />
    )}
    {Object.keys(socials).map((provider) => (
      <div className="form-group" key={provider}>
        <SocialButton
          requestType={requestType}
          network={socials[provider]}
          onClick={() => authorization(provider)}
          isLoading={isLoading}
        />
      </div>
    ))}

    {error && (
      <div className="form-group">
        <span className="inline-error">{error}</span>
      </div>
    )}
  </div>
);

export default SocialButtonsView;
